import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, Row, Col, Button, Select, Spin, Divider, Modal, notification } from 'antd';
import * as userActions from '../../redux/actions/userActions';
import { useDispatch } from 'react-redux';
import { support_table_data, manyToManyRelationData } from '../../redux/actions/customFunction';
import { formItemLayout, tailFormItemLayout } from '../../common_functions';

const ImageDesc = props => {
  const dispatch = useDispatch();
  const { section, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [supportData, setSupportData] = useState([]);
  const [imgDesc, setImgDesc] = useState();
  const [parks, setParks] = useState([]);
  const [features, setFeatures] = useState([]);
  const formRef = useRef('');
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      //get the parks
      const { data: parks } = await dispatch(
        userActions.getItems('parks', {
          fields: ['id,park'],
          limit: '-1',
          sort: 'park',
        })
      );
      setParks(parks);
      //get support table data
      const supData = await dispatch(
        userActions.getItems('support_table', {
          fields: ['id,name,fields,type'],
          limit: -1,
          filters: {
            fields: {
              _in: [
                'subject_general',
                'subject_general_landscape',
                'season',
                'landforms',
                'bodies_of_water',
                'flora',
                'atmospheric',
                'human_and_animals',
                'env_transportation',
                'env_structure',
                'env_site',
              ],
            },
          },
        })
      );
      setSupportData(supData.data);
      let imgData = await dispatch(userActions.getImageDescription(props.collectionObject.id, supData.data));
      await showFeatures(imgData.park);
      setImgDesc(imgData);
      formRef.current.setFieldsValue(imgData);
      setLoading(false);
    }
    fetchData();
  }, [section, props.collectionObject, props.negID]);
  const showFeatures = async parkID => {
    setLoading(true);
    setFeatures([]);
    if (!!parkID) {
      const { data: features } = await dispatch(
        userActions.getItems('geographic_locations', {
          fields: ['id,prominent_natural_features'],
          limit: '-1',
          sort: 'prominent_natural_features',
          filters: { park: { _eq: parkID } },
        })
      );
      setFeatures(features);
    }
    setLoading(false);
  };
  let onFinish = async values => {
    setLoading(true);
    let mergedArray = [];
    Object.entries(values).forEach(([key, value]) => {
      if (Array.isArray(value) && key != 'geographic_location' && key != 'park') {
        mergedArray = [...mergedArray, ...value];
      }
    });
    let newState = {
      ...imgDesc,
      ...values,
      negative: props?.collectionObject?.negative ?? props.negID,
      related_object: props.collectionObject.id,
      support_table_data: support_table_data(mergedArray, imgDesc),
      geographic_location: manyToManyRelationData(values.geographic_location, imgDesc),
    };
    try {
      let { data } = await dispatch(userActions.saveItem('image_description', newState));
      notification['success']({
        message: 'Image Description saved successfully!',
        duration: 2,
      });
      setLoading(false);
      setTimeout(() => props.history.push('/negatives/negative-objects/', 1500));
    } catch (error) {
      console.log(error);
      setLoading(false);
      Modal.warning({
        title: 'Error',
        content: 'Not Saved!',
      });
    }
  };
  let onFinishFailed = async ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    props.onChange('2', 'Negative');
  };
  return (
    <Spin spinning={loading} size="large">
      <Form
        ref={formRef}
        layout="vertical"
        {...formItemLayout}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{ layout: tailFormItemLayout }}
      >
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="subject_general" label="Subject General">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a subject general"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'subject_general' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="sub_gen_landscape" label="Subject, General, Landscape">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                placeholder="Select a subject, general, landscape"
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'subject_general_landscape' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="specific_sub" label="Specific Subject">
              <Input placeholder="Enter specific subject"></Input>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="depicted_loc" label="Depicted Location">
              <Input placeholder="Enter depicted location" />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="image_description" label="Image Description">
              <Input.TextArea placeholder="Enter image description..." />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="season" label="Season">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a season"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'season' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="landforms" label="Landforms">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a landforms"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'landforms' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="bodies_of_water" label="Bodies of Water">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a bodies of water"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'bodies_of_water' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="flora" label="Flora / Vegetation">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a flora / vegetation"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'flora' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="atmospheric" label="Atmospheric / Phenomenon">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a atmospheric / phenomenon"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'atmospheric' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="human_and_animals" label="Human And Animals">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a human and animals"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'human_and_animals' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="transportation" label="Built Environment - Transportation">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a built environment-transportation"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'env_transportation' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="env_structures" label="Built Environment - Structures">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a built environment structure"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'env_structure' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="site" label="Built Environment - Site">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a built environment site"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {supportData.map(
                  el =>
                    el.fields === 'env_site' && (
                      <Select.Option key={el.id} value={el.id}>
                        {el.name}
                      </Select.Option>
                    )
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="park" label="Park">
              <Select
                maxTagCount="responsive"
                // mode="multiple"
                placeholder="Select a park"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                onChange={showFeatures}
                showArrow
              >
                {parks.map(el => (
                  <Select.Option key={el.id} value={el.id}>
                    {el.park}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="geographic_location" label="Prominent Natural Features">
              <Select
                maxTagCount="responsive"
                mode="multiple"
                placeholder="Select a park"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase)}
                showArrow
              >
                {features.map(el => (
                  <Select.Option key={el.id} value={el.id}>
                    {el.prominent_natural_features}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item {...tailFormItemLayout}>
          <Button
            style={{
              margin: '0 8px',
              backgroundColor: 'lightgrey',
              color: '#333',
              borderColor: '#333',
            }}
            onClick={backButton}
          >
            Back
          </Button>
          {props.showButton()}
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default ImageDesc;
